import script from "./WizardTempDeviceRegistStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardTempDeviceRegistStep.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__